import { render, staticRenderFns } from "./settledDetail.vue?vue&type=template&id=1f67528c&scoped=true&"
import script from "./settledDetail.vue?vue&type=script&lang=js&"
export * from "./settledDetail.vue?vue&type=script&lang=js&"
import style0 from "./settledDetail.vue?vue&type=style&index=0&id=1f67528c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67528c",
  null
  
)

export default component.exports